package com.cybersoftsolution.cybersoftsolutionweb.components.text

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.CSSColor
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextOverflow
import com.varabyte.kobweb.compose.css.overflow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.textOverflow
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.whiteSpace

@Composable
fun MySpanText(
    text: String?,
    modifier: Modifier = Modifier,
    fontSize: Int = 12,
    fontStyle: FontStyle = FontStyle.Normal,
    fontColor: CSSColorValue = Color.black,
    maxLines: Int? = null
){
    SpanText(
        modifier = Modifier
            .fontSize(fontSize.px)
            .fontStyle(fontStyle)
            .color(fontColor)
            .fillMaxWidth()
            .thenIf(
                condition = maxLines != null,
                other = Modifier
                    .textOverflow(TextOverflow.Ellipsis)
                    .overflow(Overflow.Hidden)
                    .styleModifier {
                        property("display", "-webkit-box")
                        property("-webkit-line-clamp", "$maxLines")
                        property("line-clamp", "$maxLines")
                        property("-webkit-box-orient", "vertical")

                    }
            )
            .thenIf(
                condition = maxLines == 1,
                other = Modifier
                    .styleModifier {
                        whiteSpace("nowrap") // Prevent text wrapping
                        overflow(Overflow.Visible) // Allow text to overflow if necessary
                    },
            )
            .then(modifier)
        ,
        text = text.orEmpty()
    )
}